<div class="dark-blue">
  <nestas-toolbar [steps]="steps"></nestas-toolbar>
</div>
<div class="wrap audittrail-component">

  <div *ngIf="!templates.length">
    <mat-spinner *ngIf="!templates.length && !done" style="margin-left:30px;"></mat-spinner>
  </div>



  <nestas-searchbar (search)="filterTemplates($event)" [placeholder]="translate.instant('AUDITTRAIL.SEARCH_AUDITTRAIL')"
    class="flexbox wrap-search"></nestas-searchbar>

  <mat-card>
    <div *ngIf="!templates.length && done" >
      <i class="material-icons ic-info">info</i> <div style="display:inline-block; margin-left:20px;">{{translate.instant('AUDITTRAIL.NO_RESULTS')}}</div>
    </div>
    <div *ngIf="templates.length">
      <mat-card-title>{{translate.instant('AUDITTRAIL.TITLE')}}</mat-card-title>
      <div>
        {{translate.instant('AUDITTRAIL.HELP')}}
      </div>

      <br />
      <mat-slide-toggle [(ngModel)]="showMineOnly" (change)="populateTable()" color="primary">
        {{translate.instant('AUDITTRAIL.SHOW_ONLY_MINE')}}
      </mat-slide-toggle>

      <table class="default-table tight">
        <tr>
          <th style="min-width:140px">{{translate.instant('DATA.DATETIME')}}</th>
          <th style="min-width:90px">{{translate.instant('DATA.TYPE')}}</th>
          <th style="min-width:130px">{{translate.instant('DATA.DESCRIPTION')}}</th>
          <th>{{translate.instant('DATA.NAME')}}</th>
          <th>{{translate.instant('AUDITTRAIL.CONTEXT')}}</th>
          <th>{{translate.instant('AUDITTRAIL.USER')}}</th>
          <th>&nbsp;</th>
        </tr>
        <ng-container *ngFor="let ft of templates; index as i">

          <tr *ngIf="!hideCompanyTrails(ft)">
            <!-- && !hideUsedTemplates(ft) -->
            <td>
              {{ft.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}
            </td>

            <td>
              {{ft.collectionName}}
            </td>

            <td>
              {{ft.reason}}
            </td>

            <td>
              <span *ngIf="ft.reason == 'delete'">{{ft.name}}</span>
              <a *ngIf="ft.reason != 'delete'" (click)="visit(ft)">{{ft.name}}</a>
            </td>

            <td>
              <a *ngIf="ft.name" (click)="visitContext(ft)">{{ft.context|uppercase}}</a>
            </td>

            <td>
              <span *ngIf="ft.user">{{ft.user.name}}</span>
            </td>

            <td *ngIf="ft.createdAt">
              <span (click)="modal.details = ft; modal.viewDetail = true"> &nbsp; <mat-icon>visibility</mat-icon></span>
            </td>

          </tr>

        </ng-container>
      </table>
      <a *ngIf="showLoadMore()" (click)="loadMore()">...</a>

      <mat-card-actions class="clear-margin save-button"
        [ngStyle]="{'justify-content': (pid) ? 'flex-start' : 'flex-end', 'display': (pid) ? 'flex' : 'flex' }">
        <!--<button mat-raised-button color="primary" (click)="addContractor()">
        {{translate.instant('BUTTON.ACTION.ADD', {'data': 'Lijn'})}}
      </button>-->
        <button *ngIf="pid" mat-stroked-button mat-button
          (click)="cancel()">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>

      </mat-card-actions>
    </div>
  </mat-card>

  <fsmodal [show]="modal.viewDetail" [closable]=true (closed)="modal.viewDetail = false;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.COPY_PID')}}</div>
    <div class="modal-body-content">
      <div>
        <nestas-toolbar [modal]="modal"></nestas-toolbar>
      </div>
      <!--<nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="modal.pid"></nestas-pidinfo>-->

      <div class="wrap" *ngIf="modal.details">

        <h3>Meta</h3>

        <table class="default-table">
          <tr>
            <td>{{translate.instant('DATA.DATETIME')}}</td>
            <td colspan="2">{{modal.details.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
          </tr>
          <tr>
            <td>{{translate.instant('DATA.TYPE')}}</td>
            <td colspan="2">{{modal.details.collectionName}}</td>
          </tr>
          <tr>
            <td>{{translate.instant('DATA.DESCRIPTION')}}</td>
            <td colspan="2">{{modal.details.reason}} </td>
          </tr>
          <tr>
            <td>{{translate.instant('DATA.NAME')}}</td>
            <td colspan="2">{{modal.details.name}}</td>
          </tr>
          <tr>
            <td>{{translate.instant('AUDITTRAIL.CONTEXT')}}</td>
            <td colspan="2">{{modal.details.context}}</td>
          </tr>
          <tr>
            <td>{{translate.instant('AUDITTRAIL.USER')}}</td>
            <td colspan="2"><span *ngIf="modal.details.user">{{modal.details.user.name}}</span></td>
          </tr>
        </table>

        <h3 *ngIf="modal.details.diffs.length">Details</h3>
        <table class="default-table">
          <tr *ngFor="let k of modal.details.diffs">
            <td>{{k[0]}}</td>
            <td>{{k[1]}}</td>
            <td>{{k[2]}}</td>
          </tr>
        </table>


      </div>
      <div class="wrap">
        <!--<new-pid #modalCopyPID *ngIf="modal.newPID" [copyOf]="modal.pid" [parentPID]="modal.pid.parentPID"
          [pids]="pids.all" (cancelled)="modal.newPID = false;"></new-pid>-->
        <!-- (done)="reload()"-->
        <div style="margin-top:40px; margin-bottom:120px;">
          <button mat-button mat-stroked-button
            (click)="modal.viewDetail = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
          <!--<button mat-raised-button (click)="modalCopyPID.addPID(this.updateall);" color="primary">
            {{translate.instant('BUTTON.ACTION.SAVE')}}
          </button>-->
        </div>
      </div>
    </div>
  </fsmodal>

</div>